import React from "react";
import Layout from "../../components/Layout/Page";
import CeoMessage from "./components/ceoMessage";
import Gallery from "./components/Gallery";
import OurProjects from "./components/ourProjects";
import OurServices from "./components/ourServices";
import NumbersComponent from "./components/projectNumbers";
import Enlishments from "./components/registrationSlider";
import HomePageSlider from "./components/topSlider";
import WhoWeAre from "./components/whoWeAre";

const Home = () => {
  return (
    <>
      <Layout>
        <HomePageSlider />
        <WhoWeAre />
        <OurServices />
        <NumbersComponent />
        <OurProjects />
        <CeoMessage />
        <Enlishments />
        <Gallery />
      </Layout>
    </>
  );
};

export default Home;
